export const SET_NOTIF_DATA = 'notificatoin/set-notif-data';
export const SET_NOTIFLIST_DATA = 'notificatoin/set-notiflist-data';
export const SET_MORE_NOTIFLIST_DATA = 'notificatoin/set-more-notiflist-data';
export const RESET_NOTIF_DATA = 'notificatoin/reset-notif-data';
export const UNREAD_NOTIF_DATA = 'notificatoin/unread-notif-data';
export const SET_NOTIFSETTINGS_DATA = 'notificatoin/set-notif-settings-data';
